<template lang="pug">
    section
        v-sheet(color="grey lighten-5" outlined)
            v-container(fluid).pa-0
                v-skeleton-loader(type='card' height="500" min-height="500" v-if="loading" tile)
                v-card(v-if="!loading")
                    h1 {{series.data}}
                    apexchart(type="line" height="500" :options="chartOptions" :series="series")
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    import ClientApi from '@/api/client'

    export default {
        name: "ClientPortfolio",
        components: {
            'apexchart': VueApexCharts
        },
        computed: {
            userPortfolio () {
                return this.$store.state.client.userPortfolio
            },
        },
        data () {
            return {
                loading: true,
                series: [
                    {
                        name: "Доходность, %",
                        data: []
                    }
                ],
                chartOptions: {
                    chart: {
                        height: 400,
                        locales:[{
                            name: 'en',
                            options: {
                                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                                shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                                days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                                shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                                toolbar: {
                                    exportToSVG: 'Сохранить SVG',
                                    exportToPNG: 'Сохранить PNG',
                                    menu: 'Menu',
                                    selection: 'Выбор',
                                    selectionZoom: 'Выбор с увеличением',
                                    zoomIn: 'Увеличить',
                                    zoomOut: 'Уменьшить',
                                    pan: 'Перемещение',
                                    reset: 'Сбросить'
                                }
                            }
                        }],
                    },

                    annotations: {
                        xaxis: []
                    },
                    tooltip: {
                        followCursor: false,
                        theme: 'dark',
                        x: {
                            show: true
                        },
                        marker: {
                            show: false
                        },
                        y: {
                            title: {
                                formatter: function() {
                                    return 'Доходность, %'
                                }
                            }
                        }
                    },
                    stroke: {
                        colors: this.$vuetify.theme.primary,
                        width:2,
                        lineCap: 'butt',
                    },
                    title: {
                        align: 'left'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                        padding:{
                            right:50,
                        }
                    },
                    xaxis: {
                        type: "datetime",
                        labels:{
                            format: 'dd.MM.yyyy',
                            showDuplicates: false,
                            style:{
                                fontSize: '14px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                cssClass: 'apexcharts-xaxis-label',
                            }
                        },
                        axisTicks: {
                            show: true,
                            borderType: 'solid',
                            color: '#78909C',
                            height: 6,
                            offsetX: 100,
                            offsetY: 0
                        },
                    },
                    yaxis: {
                        title:{
                            text: 'Доходность, %'
                        },
                        labels: {
                            show: true,
                            minWidth: 0,
                            maxWidth: 160,
                            style: {
                                color: undefined,
                                fontSize: '12px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                cssClass: 'apexcharts-yaxis-label',
                            },
                            offsetX: 0,
                            offsetY: 0,
                            rotate: 0,
                            formatter: (value) => { return value.toFixed(2) },
                        },
                        crosshairs: {
                            show: true,
                            position: 'back',
                            stroke: {
                                color: '#b6b6b6',
                                width: 1,
                                dashArray: 0,
                            },
                        },
                    }
                },
            }
        },
        created () {
            ClientApi.getClientProfitability(this.$store.state.auth.user.id, )
                .then( response => {
                    this.series = [{
                        data: response.timeseries
                    }]
                    // for (let i in response.events){
                    //     this.chartOptions.annotations.xaxis.push({
                    //         x: new Date(response.events[i].date).getTime(),
                    //         borderColor: '#775DD0',
                    //         label: {
                    //             style: {
                    //                 color: '#333',
                    //             },
                    //             text: response.events[i].type + ' ' + response.events[i].symbol
                    //         }
                    //     })
                    // }

                    this.loading = false
                })
        }
    }
</script>

<style scoped>

</style>
